module.exports = __webpack_public_path__ + "assets/Excessive Overbite.38417534a0fa7a9d6f51680240cf28a8.png";